var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFredHighlighted(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 53.039,
    height: 59.748,
    viewBox: "0 0 53.039 59.748",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_29414",
    "data-name": "Group 29414",
    transform: "translate(-355 -422.165)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "svgexport-7_20_",
    "data-name": "svgexport-7 (20)",
    transform: "translate(355 422.165)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_48766",
    "data-name": "Path 48766",
    d: "M76.459,46.592a.961.961,0,1,1,.9-1.7,11.014,11.014,0,0,1,3.2,2.393,4.54,4.54,0,0,1,1.231,2.987c0,2.811-3.113,5.254-8.148,6.93a60.509,60.509,0,0,1-18.371,2.546A60.5,60.5,0,0,1,36.9,57.2c-5.035-1.676-8.148-4.119-8.148-6.93a4.544,4.544,0,0,1,1.231-2.987,11.015,11.015,0,0,1,3.2-2.393.961.961,0,1,1,.9,1.7,9.161,9.161,0,0,0-2.643,1.949,2.689,2.689,0,0,0-.757,1.73c0,1.89,2.609,3.7,6.824,5.108a58.6,58.6,0,0,0,17.769,2.44,58.606,58.606,0,0,0,17.77-2.44c4.216-1.4,6.823-3.217,6.823-5.107a2.687,2.687,0,0,0-.757-1.73,9.144,9.144,0,0,0-2.643-1.949ZM48.677,43.021a24.169,24.169,0,0,0-6.952,1.915c-1.483.729-2.35,1.52-2.35,2.284,0,1.09,1.634,2.179,4.274,3.058a38.326,38.326,0,0,0,11.618,1.592,38.324,38.324,0,0,0,11.618-1.592c2.641-.88,4.275-1.969,4.275-3.058,0-.764-.866-1.555-2.351-2.284a24.166,24.166,0,0,0-6.951-1.915,35.368,35.368,0,0,1-6.087,4.956.959.959,0,0,1-1.028-.012,35.482,35.482,0,0,1-6.067-4.944ZM55.267,8.5a10.049,10.049,0,1,1-7.107,2.943A10.049,10.049,0,0,1,55.267,8.5Zm5.744,4.306a8.122,8.122,0,1,0,2.379,5.743,8.122,8.122,0,0,0-2.379-5.743ZM49.977,41.6a34.97,34.97,0,0,0,5.29,4.425,35.047,35.047,0,0,0,5.29-4.423A46.03,46.03,0,0,0,71.012,25.761c2.178-5.913,2.527-12.143-.78-17.476a18.044,18.044,0,0,0-2.6-3.245,17.69,17.69,0,0,0-24.732,0,18.044,18.044,0,0,0-2.6,3.245c-3.307,5.333-2.958,11.563-.779,17.476A46.009,46.009,0,0,0,49.977,41.6Z",
    transform: "translate(-28.748 0)",
    fill: "#1a74e2",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_284",
    "data-name": "Ellipse 284",
    cx: 15.884,
    cy: 15.884,
    r: 15.884,
    transform: "translate(10.685 1.444)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_29402",
    "data-name": "Group 29402",
    transform: "translate(373 428.379)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_50277",
    "data-name": "Path 50277",
    d: "M37.475,42.58,35.685,39,33,41.685Z",
    transform: "translate(-20.953 -21.557)",
    fill: "#0277bd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50278",
    "data-name": "Path 50278",
    d: "M31.383,39.009,34.792,39l-.9,4.018H32.032Z",
    transform: "translate(-20.06 -21.557)",
    fill: "#039be5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50279",
    "data-name": "Path 50279",
    d: "M15.889,6.82s4.922-.862,4.922-3.647-3.194-4.893-8.55-1.08C7.077.722,5.149,5.8,6.519,9.018c-1.457,3.428.986,6.528,3.257,6.142C9.991,13.7,15.889,6.82,15.889,6.82Z",
    transform: "translate(-6.08 -0.022)",
    fill: "#ffeb3b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50280",
    "data-name": "Path 50280",
    d: "M21.505,31.892l.429,3.285h-9l.914-7.2Z",
    transform: "translate(-9.868 -15.468)",
    fill: "#efad60"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50281",
    "data-name": "Path 50281",
    d: "M12.362,19.646a6.213,6.213,0,0,0,4.868,4.579c1.585.257,3.951-.091,4.251-.948A44.5,44.5,0,0,0,22.6,17.921c0-.514-1.585-1.842-1.2-2.914a4.881,4.881,0,0,0-.214-2.7,7.542,7.542,0,0,1-6.77.643,1.891,1.891,0,0,1-1.885,1.714,3.117,3.117,0,0,1-.171,3.771A1.8,1.8,0,0,0,11.5,16.85s-.985-.343-1.285.428.214,2.785,1.157,3.085S12.27,20.021,12.362,19.646Z",
    transform: "translate(-8.316 -6.81)",
    fill: "#ffcc80"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50282",
    "data-name": "Path 50282",
    d: "M21.17,19.066h1.964s.816-1.541-.408-1.566A1.617,1.617,0,0,0,21.17,19.066Z",
    transform: "translate(-14.417 -9.678)",
    fill: "#eee"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50283",
    "data-name": "Path 50283",
    d: "M30.043,19.809a2.32,2.32,0,0,0,1.142,1.942,2.625,2.625,0,0,1-.628,1,2.183,2.183,0,0,0,1.342-1.2C30.9,21.266,30.043,19.809,30.043,19.809Z",
    transform: "translate(-19.32 -10.954)",
    fill: "#efad60"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50284",
    "data-name": "Path 50284",
    d: "M23.021,41.652l3.285.514,1.028-1.457.914-.029,1.075,3.266-4.96-.009Z",
    transform: "translate(-15.44 -22.486)",
    fill: "#ff5722"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50285",
    "data-name": "Path 50285",
    d: "M28.329,28.633l.021.967.493-.021-.657,1.586.007-.688s-3.078.8-4.406-1.236A23.021,23.021,0,0,1,28.329,28.633Z",
    transform: "translate(-15.863 -15.829)",
    fill: "#efad60"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50286",
    "data-name": "Path 50286",
    d: "M28.58,27.61l-1.092.878-4.435.15A6.944,6.944,0,0,1,28.58,27.61Z",
    transform: "translate(-15.458 -15.171)",
    fill: "#efad60"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50287",
    "data-name": "Path 50287",
    d: "M28.58,29v.9s-2.685.9-3.58-.448A14.394,14.394,0,0,1,28.58,29Z",
    transform: "translate(-16.533 -16.032)",
    fill: "#eee"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50288",
    "data-name": "Path 50288",
    d: "M21.765,19a.668.668,0,0,0-.349.1,1.936,1.936,0,0,0-.246.795H22.4a.664.664,0,0,0,.041-.224A.671.671,0,0,0,21.765,19Z",
    transform: "translate(-14.417 -10.508)",
    fill: "#212121"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50289",
    "data-name": "Path 50289",
    d: "M31.17,19.132h1.516s.4-1.294-.178-1.476C31.594,17.37,31.177,18.8,31.17,19.132Z",
    transform: "translate(-19.942 -9.744)",
    fill: "#eee"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50290",
    "data-name": "Path 50290",
    d: "M31.765,19a.668.668,0,0,0-.349.1,1.936,1.936,0,0,0-.246.795H32.4a.664.664,0,0,0,.041-.224A.671.671,0,0,0,31.765,19Z",
    transform: "translate(-19.942 -10.508)",
    fill: "#212121"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50291",
    "data-name": "Path 50291",
    d: "M22.685,15.555S21.342,15.108,20,16.9C20.447,15.555,21.342,14.66,22.685,15.555Z",
    transform: "translate(-13.771 -8.405)",
    fill: "#212121"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50292",
    "data-name": "Path 50292",
    d: "M32,14.67s1.371,0,1.581.9C33.342,14.222,32.447,14.222,32,14.67Z",
    transform: "translate(-20.401 -7.967)",
    fill: "#212121"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50293",
    "data-name": "Path 50293",
    d: "M29.895,24.448,29,24.9l.447-.9Z",
    transform: "translate(-18.743 -13.27)",
    fill: "#efad60"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50294",
    "data-name": "Path 50294",
    d: "M18.817,43.215l-2.1-3.875L13,41.873Z",
    transform: "translate(-9.903 -21.745)",
    fill: "#0277bd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50295",
    "data-name": "Path 50295",
    d: "M9.637,36,7.723,39.333l4.151,2.037L13.8,37.495Z",
    transform: "translate(-6.988 -19.9)",
    fill: "#039be5"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFredHighlighted);
export default __webpack_public_path__ + "static/media/fredHighlighted.02d82cbe04baab4fd7f240235f113485.svg";
export { ForwardRef as ReactComponent };